import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useConfig from 'app/hooks/useConfig';
import { NavTabs } from 'app/components';
import { NavTabsWrapper } from './styles';

const { NavTabsList, NavTabsItem } = NavTabs;
const propTypes = {
  date: PropTypes.string,
  historySearch: PropTypes.string.isRequired,
  selectedLocation: PropTypes.string.isRequired
};

const defaultProps = {
  date: null
};

const getMovieSectionUrlBase = routes => (to, historySearch, location, date) => {
  const urlParams = new URLSearchParams(historySearch);

  urlParams.set('category', to);

  if (to === 'upcoming') {
    urlParams.set('date', 'all');
    urlParams.delete('location');
  } else {
    urlParams.set('date', date);
    urlParams.set('location', location);
  }

  return {
    pathname: routes.movies.pattern,
    search: `?${urlParams.toString()}`
  };
};

const NavTabsMovies = ({ date, historySearch, selectedLocation }) => {
  const [t] = useTranslation();
  const { routes } = useConfig();
  const getMovieSectionUrl = getMovieSectionUrlBase(routes);

  return (
    <NavTabsWrapper>
      <NavTabsList>
        <NavTabsItem
          to={getMovieSectionUrl('top', historySearch, selectedLocation, date)}
          isSelected={historySearch.indexOf('top') >= 0}
          text={t('common.top_movies')}
        />
        <NavTabsItem
          to={getMovieSectionUrl('now', historySearch, selectedLocation, date)}
          isSelected={historySearch.indexOf('now') >= 0}
          text={t('common.now_playing')}
        />
        <NavTabsItem
          to={getMovieSectionUrl('upcoming', historySearch)}
          isSelected={historySearch.indexOf('upcoming') >= 0}
          text={t('common.upcoming')}
        />
      </NavTabsList>
    </NavTabsWrapper>
  );
};

NavTabsMovies.propTypes = propTypes;
NavTabsMovies.defaultProps = defaultProps;
export default NavTabsMovies;
